<template>
    <div id="about-area" class="about-area bg-sky bg-relative pd-bottom-80">
        <img class="top_image_bounce position-bottom-left" :src="require('@/assets/img/about/7.png')" alt="img">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 col-md-9 wow animated fadeInLeft" data-wow-duration="1.5s" data-wow-delay="0.3s">
                    <div class="about-thumb-area pb-0 pe-0 me-0">
                        <img class="about-img-1" :src="require('@/assets/img/about/smaco-11.jpg')" height="350px" width="600px" alt="img">
                    </div>
                </div>
                <div class="col-lg-5 align-self-end wow animated fadeInRight" data-wow-duration="1.5s" data-wow-delay="0.3s">
                    <div class="section-title about-section-title mb-0">
                        <h6 class="sub-title">Empresa Confiable</h6>
                        <h2 class="title title-small">Nuestro compromiso</h2>
                        <ul class="mission-vision-tab nav nav-pills mb-3 mt-3" id="pills-tab" role="tablist">
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                <div class="mission-vision-content">
                                    <p  style="text-align: justify;">En Smaco, creemos en la colaboración y la comunicación transparente con nuestros clientes. Trabajamos en estrecha colaboración contigo para entender tus necesidades y garantizar que nuestras soluciones aborden los desafíos específicos de tu negocio.
                                    Valoramos la satisfacción del cliente y nos esforzamos por establecer relaciones a largo plazo basadas en la confianza y el éxito mutuo. Estamos comprometidos con la excelencia y nos enorgullece la calidad de nuestro trabajo y la dedicación de nuestro equipo.
                                    ¡Estamos emocionados de trabajar contigo y ayudarte a alcanzar tus objetivos! Si deseas saber más sobre nuestros servicios o tienes alguna pregunta, no dudes en ponerte en contacto con nosotros.

                                    </p> 
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: "AboutArea",
    }
</script>


// WEBPACK FOOTER //
// src/components/page/about/AboutArea.vue